import React from 'react';
import styled from 'styled-components';

const AvatarWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${props => props.width}px;
	height: ${props => props.width}px;
	border-radius: 50%;
	background: linear-gradient(
		135deg,
		${props => props.theme.colors.primaryLight} 15%,
		${props => props.theme.colors.primary},
		${props => props.theme.colors.secondary},
		${props => props.theme.colors.secondaryLight} 85%
	);
`;

const AvatarBackground = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${props => props.width}px;
	height: ${props => props.width}px;
	border-radius: 50%;
	background: #ffffff;
	box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
`;

const AvatarContent = styled.div`
	width: ${props => props.width}px;
	height: ${props => props.width}px;
	border-radius: 50%;
	background-image: url(${props => props.image});
	background-position: center top;
	background-size: cover;
`;

interface IAvatar {
	avatar?: string;
	width: number;
	component?: JSX.Element
}

const Avatar = ({ avatar, width, component }: IAvatar): JSX.Element => (
	<AvatarWrapper width={width}>
		<AvatarBackground width={width - 4}>
			{
				component || <AvatarContent width={width - 8} image={avatar} />
			}
		</AvatarBackground>
	</AvatarWrapper>
);

export default Avatar;
